import { useInfiniteQuery } from '@northladder/services';

import { INBOUND_API } from '../../../inboundAPIClient';
import { IFetchSearchListUrlOptions } from '../../../types';

import { formatInboundsListResponse } from '../transformers';

/**
 * This is to track the device categories from the backend.
 */
export const INBOUND_SEARCH_LIST_KEY = 'inbound-package-list-query';

interface IInboundSearchListQuery {
  enabled?: boolean;
  gcTime?: number;
  queryParams: IFetchSearchListUrlOptions;
  staleTime?: number;
}

/**
 * This hook fetches list of inbound items from mock APi.
 */
export const useSearchInboundListQuery = ({
  enabled,
  gcTime,
  queryParams,
  staleTime,
}: IInboundSearchListQuery) => {
  const {
    endDate,
    filterKey,
    limit,
    search,
    searchFields,
    searchKeywords,
    showOnly,
    sort,
    startDate,
    recordType,
  } = queryParams;

  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  } = useInfiniteQuery({
    gcTime,
    enabled,
    staleTime,
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [
      INBOUND_SEARCH_LIST_KEY,
      endDate,
      filterKey,
      search,
      searchFields,
      searchKeywords,
      showOnly,
      sort,
      startDate,
      recordType,
    ],
    networkMode: 'always',
    initialPageParam: 1,
    queryFn: ({ pageParam = 1 }) =>
      INBOUND_API.fetchInboundList({ ...queryParams, page: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = allPages.length + 1;
      const currentCount = allPages.length * limit;

      return currentCount < lastPage.total ? nextPage : undefined;
    },
  });

  return {
    data: formatInboundsListResponse(data),
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetchInboundList: refetch,
  };
};
